import styled from '@emotion/styled';
import { helperAbsoluteFill, media } from '@utex/ui-kit';
interface ContentProps {
  backgroungColor?: string;
}

export const Content = styled('div')<ContentProps>`
  ${helperAbsoluteFill};
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  background-color: ${(props) => props.backgroungColor};
  border-radius: inherit;
`;

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  padding: 4rem;
  text-align: center;
`;

export const Footer = styled('div')`
  padding: 0 4rem 4rem;

  @media ${media.phonablet} {
    align-self: normal;
    padding: 0 1.6rem 1.6rem;
  }
`;
